import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PIPELINE_STEP_SHAPES} from 'pipelines/GeneratedPipelineStepShapes';
import {PipelineJsonSpecToTsType} from 'pipelines/PipelineTypes';
import ErrorSubclass from 'util/ErrorSubclass';

// We need a special prefix to tell when a string should be treated as a column
// Keep in sync with benchling/pipelines/step_type_library/step_shape_declarations/step_shape_constants.py
export const COLUMN_REFERENCE_PREFIX = '$c$';
export const COLUMN_REFERENCE_REGEX = /"\$c\$(?<columnSystemName>.+?)"/g;
export const COLUMN_REFERENCE_AT_START_REGEX = /^"\$c\$(?<columnSystemName>.+?)"/;

export class AnalysisFormulaParsingError extends ErrorSubclass {}

const FORMULA_AST_SHAPE =
  PIPELINE_STEP_SHAPES[PipelineStepType.COMPUTED_COLUMN][0].config.formula.fields.formulaAst;
export type FormulaAst = PipelineJsonSpecToTsType<typeof FORMULA_AST_SHAPE>;

// Keep in sync with benchling/pipelines/step_type_library/step_shape_declarations/computed_column_step_shapes.py
export const COLUMN_REFERENCE_TYPE = 'COLUMN_REFERENCE';
export const STRING_LITERAL_TYPE = 'STRING_LITERAL';
export const NUMBER_LITERAL_TYPE = 'NUMBER_LITERAL';
export const BOOLEAN_LITERAL_TYPE = 'BOOLEAN_LITERAL';
export const OPERATION_TYPE = 'OPERATION';
